import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "92%",
    width: "100%",
    border: "2px solid #6C65D9",
    borderRadius: "20px",
    padding: "16px",
    fontSize: "14px",
  },
  activeContainer: {
    overflowX: "none",
    overflowY: "auto",
    padding: "5px",
    maxHeight: "67%",
    [theme.breakpoints.down("lg")]: {
      maxHeight: "48%",
    },
  },
  activeTaskContainer: {
    overflowX: "none",
    overflowY: "auto",
    padding: "5px",
    maxHeight: "63%",
    [theme.breakpoints.down("lg")]: {
      maxHeight: "60%",
    },
  },
  activeTaskContainerExpanded: {
    overflowX: "none",
    overflowY: "auto",
    padding: "5px",
    maxHeight: "63%",
    [theme.breakpoints.down("lg")]: {
      maxHeight: "40%",
    },
  },
  inactiveContainer: {
    overflowX: "none",
    overflowY: "auto",
    padding: "5px",
    maxHeight: "82%",
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spaceBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontSize: "12px",
  },
  tertiaryColor: {
    color: theme.palette.text.tertiary,
    width: "45%",
    display: "flex",
    justifyContent: "flex-end",
  },
  heading: {
    fontSize: "32px !important",
  },
  addToDoButton: {
    color: theme.palette.secondary.main,
    margin: "4px auto",
    [theme.breakpoints.down("lg")]: {
      margin: "0px auto",
    },
  },
  versionName: {
    color: theme.palette.secondary.main,
    marginLeft: "10px",
    marginTop: "6px",
    width: "50%",
  },
  divider: {
    backgroundColor: theme.palette.secondary.main,
  },
  tabActive: {
    backgroundColor: theme.palette.secondary.main,
    minWidth: "0px",
    padding: "6px 10px",
    borderRadius: "5px 5px 0px 0px",
  },
  tabInactive: {
    backgroundColor: theme.palette.secondary.light,
    minWidth: "0px",
    padding: "6px 10px !important",
    borderRadius: "5px 5px 0px 0px",
  },
  menuPop: {
    backgroundColor: theme.palette.secondary.light,
    border: `1px solid ${theme.palette.text.tertiary}`,
    borderRadius: "5px",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  deleteColor: {
    color: "#F40A0A",
  },
  taskItemContainer: {
    height: "70%",
    overflowX: "none",
    overflowY: "auto",
    padding: "5px",
    [theme.breakpoints.down("lg")]: {
      height: "58%",
    },
  },
  linkVersion: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "4px",
    fontSize: "12px",
    color: theme.palette.text.tertiary,
    marginTop: "-10px",
  },
}));

export default useStyles;
